import React from 'react';
import 'twin.macro';
import Editor from 'components/Editor/Loadable';
import HtmlViewer from 'components/HtmlViewer';
import _isEmpty from 'lodash-es/isEmpty';
import { ROSelect } from 'containers/Eleves/List/Table/Cells/components/ROSelect';
import useDebounce from 'utils/useDebounce';

interface Props {
  value: string;
  onChange: (v: string) => void;
  readonly?: boolean;
  'aria-label'?: string;
}

export function RichText(props: Props) {
  const { onChange, value, readonly } = props;
  const [editing, setEditing] = React.useState<boolean>(false);
  const [text, setText] = React.useState<string>(value);
  const debouncedSave = useDebounce(nextValue => onChange(nextValue), 500);
  if (readonly) {
    return (
      <div>
        <HtmlViewer
          text={value}
          onChange={v => {
            setText(v);
            debouncedSave(v);
          }}
        />
      </div>
    );
  }
  if (!editing) {
    return (
      <div tw="max-w-[8rem]">
        <ROSelect onClick={() => setEditing(true)}>
          {_isEmpty(text) ? (
            <div tw="invisible">Texte invi</div>
          ) : (
            <HtmlViewer
              onChange={v => {
                setText(v);
                debouncedSave(v);
              }}
              text={text}
            />
          )}
        </ROSelect>
      </div>
    );
  }
  return (
    <div tw="max-w-[8rem]">
      <Editor
        inline
        tw="border-opacity-0 hover:border-opacity-100"
        value={text}
        autoFocus
        aria-label={props['aria-label']}
        onChange={v => {
          setText(v);
          debouncedSave(v);
        }}
        onBlur={() => {
          setEditing(false);
        }}
      />
    </div>
  );
}
